import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ag-shr-change-log-downloaded-media-detail',
  templateUrl: './change-log-downloaded-media.component.html',
  styleUrls: ['./change-log-downloaded-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogDownloadedMediaComponent {
  @Input() log: string[] = [];
}
